module.exports = __webpack_public_path__ + "img/logo.53217a13.png";